import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import WorkSpacesLogoSVG from '../../assets/images/workspaces-logo.svg';
import { useTranslation } from 'react-i18next';
import PoweredByBrand from '../powered-by-brand';
import { CenteredDiv, Motto, Spinner, } from '../styles/commonstyles';
// Loader component
const Loader = () => {
    const { t } = useTranslation();
    return (_jsxs(CenteredDiv, { children: [_jsx(Spinner, {}), _jsx("img", { src: WorkSpacesLogoSVG }), _jsx("br", {}), _jsx(Motto, { children: t('common.smartworkspaces.moto') }), _jsx("br", {}), _jsx("br", {}), _jsx(PoweredByBrand, {})] }));
};
export default Loader;
